export default "__VITE_ASSET__BPGaQWwt__"